export const UPDATE_LAWS_AFTER_READ_USERACTION = 'UPDATE_LAWS_AFTER_READ_USERACTION';
export const UPDATE_LAWS_AFTER_RATE_USERACTION = 'UPDATE_LAWS_AFTER_RATE_USERACTION';
export const UPDATE_LAWS_AFTER_CHANGE_IMPORTANCE = 'UPDATE_LAWS_AFTER_CHANGE_IMPORTANCE';
export const UPDATE_LAWS_AFTER_CHANGE_ECOSYSTEM_STATE = 'UPDATE_LAWS_AFTER_CHANGE_ECOSYSTEM_STATE';
export const UPDATE_LAWS_AFTER_CHANGE_PLAN_STATUS = 'UPDATE_LAWS_AFTER_CHANGE_PLAN_STATUS';
export const CLEAN_PERSISTED_STORAGE = 'CLEAN_PERSISTED_STORAGE';

export const APPLY_COVID_FILTERS = 'APPLY_COVID_FILTERS';
export const APPLY_SEMANTIC_FILTERS = 'APPLY_SEMANTIC_FILTERS';



// WEBPACK FOOTER //
// ./src/redux_related/GENERAL/actions.js